<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}知识</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card" style="">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">知识基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="知识编号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成知识编号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="知识名称" prop="name">
                <el-input v-model="form.name" placeholder="请填写知识名称" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="知识类型" prop="category">
                <el-select v-model="form.category" style="width: 90%" clearable placeholder="请选择知识类型" :filter-method="getDocumentTypes">
                  <el-option v-for="item in STATIC_DocumentType" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width:90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width:90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="知识内容" prop="content">
                <el-input v-model="form.content" placeholder="请填写知识内容" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="" prop="fileInfos">
                <!-- <my-upload
                  :canEdit="editMode"
                  @filesChange="filesChange"
                  :oldList="form.fileInfos"
                ></my-upload> -->
                <UploadFileList label="上传附件" :fileList="form.fileInfos ? [form.fileInfos[0]] : []" btnShowType="always" :multipleFile="false" :showFileList="false" :editMode="editMode" @fileChange="filesChange"></UploadFileList>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <!-- <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import { SaveKnowBase, GetKnowBaseById } from "@/api";
import { KnowBaseCategoryCptions } from "@/enum";
// import Address from '@/components/address';
// import ElImageViewer from '@/components/elImageViewer'
import MyUpload from "@/components/my-upload";
import UploadFileList from "@/components/upload-file-list";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    MyUpload,
    UploadFileList,
  },
  data () {
    return {
      editMode: false,
      title: "",
      form: {},
      KnowBaseCategoryCptions: KnowBaseCategoryCptions,
      rules: {
        name: [
          { required: true, message: "资产名称不能为空", trigger: "blur" },
        ],
        specName: [
          { required: true, message: "规格型号不能为空", trigger: "blur" },
        ],
        unitName: [
          { required: true, message: "资产单位不能为空", trigger: "blur" },
        ],
        brandName: [
          { required: true, message: "资产品牌不能为空", trigger: "blur" },
        ],
        price: [
          { required: true, message: "资产单价不能为空", trigger: "blur" },
        ],
        assetType: [
          { required: true, message: "资产类型不能为空", trigger: "blur" },
        ],
        supplierName: [
          { required: true, message: "供应商不能为空", trigger: "blur" },
        ],
        manufacturerName: [
          { required: true, message: "生产厂家不能为空", trigger: "blur" },
        ],
      },

      // fileId: 0,
      // fileName: '',
      // openViewer: false
    };
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo;
    },
  },
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.getDocumentTypes();
    this.initWorkFlowProperty();
  },
  methods: {
    // 新建
    handleAdd () {
      this.title = "新建";
      this.resetForm();
    },
    // 编辑
    handleUpdate (id) {
      GetKnowBaseById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.title = "编辑";
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveKnowBase(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        state: 1,
        category: "",
        createdTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm('确认要中断当前操作吗？', '提示', {
      //   type: 'warning'
      // })
      //   .then(() => {
      //     this.$router.go(-1);
      //   })
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },

    // change event

    // 上传附件
    filesChange (fileList) {
      this.form.fileInfos = fileList;
    },
    // openImageViewer (e) {
    //   this.openViewer = true;
    //   if (e.percentage) {
    //     this.fileId = e.response.returnData[0].id
    //     this.fileName = e.response.returnData[0].name
    //   }
    //   else {
    //     this.fileId = e.id
    //     this.fileName = e.name
    //   }
    // },
    // closeImageViewer () {
    //   this.openViewer = false;
    // },
    // // 当上传完文件以后
    // onUploadSuccess (response, file, fileList) {
    //   if (!this.form.fileInfos) {
    //     this.form.fileInfos = [];
    //   }

    //   this.form.fileInfos.push(...response.returnData);
    //   this.form.files = this.form.fileInfos.map(e => e.id).join(';')
    // },
    // // 删除文件以后
    // onFileRemove (file, fileList) {
    //   this.form.fileInfos = fileList
    // },
  },
};
</script>

<style lang="scss" scoped>
.edit-card {
  height: calc(100vh - 200px);
}
</style>
